import { useEffect } from 'react';
// import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';

import { PopularLocality } from '@restworld/data-services';
// import { useAuthContext } from '@restworld/feature-authentication';

import { IJobPositionsOfStaticOccupationProps } from '../components/home';
import { JobDomainInterestCount } from '../components/home/blocks/job-positions-per-domain';
// import HomeLayout from '../components/home/home-layout';
import { HomeContextProvider } from '../components/home/home.context';
// import { serverFetchJpData } from '../components/home/server-side/fetch-jp-data';
// import { useStoreImages } from '../components/home/context/static-images';
// import { getServerTranslations } from '../lib/i18n/getServerTranslations';

export type HomeStaticPropsType = {
  jobsPerDomains: JobDomainInterestCount[];
  popularLocalities: PopularLocality[];
  staticOccupations: IJobPositionsOfStaticOccupationProps['staticOccupations'];
  images: { [imgKey: string]: { blurDataURL: string; src: string } };
};
const HomePage = (props) => (
  <HomeContextProvider>
    <PageContent />
  </HomeContextProvider>
);
export default HomePage;
const PageContent = () => {
  // const { setRenderPage } = useHomeContext();
  // const { isAuthenticated, user } = useAuthContext();
  const { push: routerPush } = useRouter();
  // useStoreImages(props.images);

  useEffect(() => {
    routerPush('/cerco-lavoro');
  }, [routerPush]);

  // return <HomeLayout {...props} />;
  return null;
};
// export const getStaticProps: GetServerSideProps<HomeStaticPropsType> = async ({ locale }) => {
//   // const jpData = await serverFetchJpData();

//   const transConfig = await getServerTranslations(locale, ['common', 'home-page', 'auth-flow', 'onboarding-page']);

//   return {
//     props: { ...transConfig },
//     revalidate: 60,
//   };
// };
